angular.module('bizmetryApp').controller('AgentStatsDialogController', function (
    $scope, $mdDialog, agent, TelemetryAgentService, ConfigurationService, $timeout, dialogService, LiveChartViewport
) {
    // Live charts show twenty buckets at the live aggregation interval.
    const LIVE_POINT_COUNT = 20;
    $scope.agent = agent;
    $scope.loading = true;
    $scope.aggregatedData = [];
    $scope.totalIntervals = 0;
    $scope.noDataMessage = '';
    $scope.timeRangeLoading = true;

    // ===== INSTANCIAS (HA) — panel izquierdo =====
    // null = "Todas las instancias" (comportamiento agregado de siempre).
    $scope.instances = [];
    $scope.selectedPodName = null;

    TelemetryAgentService.getAgentInstances($scope.agent.agentId, $scope.agent.accountId)
        .then(function (response) { $scope.instances = response.data || []; })
        .catch(function (error) { console.warn('AgentStats: error loading instances', error); });

    var skipLiveCaptureOnce = false;
    $scope.selectInstance = function (podName) {
        if ($scope.selectedPodName === podName) return;
        $scope.selectedPodName = podName;
        skipLiveCaptureOnce = true;
        if (chartInstance) LiveChartViewport.cancel(chartInstance);

        // La latencia ya no se captura a nivel instancia (es agent-level) —
        // al elegir una instancia puntual, no tiene sentido ofrecerla.
        if (podName) {
            $scope.metrics.latency = false;
            var latencyIdx = $scope.selectedMetrics.indexOf('latency');
            if (latencyIdx !== -1) $scope.selectedMetrics.splice(latencyIdx, 1);
            if (chartInstance) {
                chartInstance.setDatasetVisibility(METRIC_DATASET_INDEX.latency, false);
                chartInstance.update();
            }
        }

        $scope.page = 'LAST';
        $scope.loadMetrics();
    };

    // ✅ PAGINACIÓN
    $scope.page = 0;
    $scope.totalPages = 0;
    $scope.pageSizeOptions = [15, 30, 45, 60];
    $scope.isChangingInterval = false;
    $scope.isLoadingChart = false;
    $scope.activeTimePreset = null;

    // ✅ Live Monitoring
    $scope.isLiveMode = false;
    let liveMonitoringInterval = null;

    // ===== METRIC VISIBILITY =====

    $scope.metrics = {
        cpu: false, memory: false, latency: false, logPressure: false, queuePressure: true,
        queueUsage: false, heapUsage: false, safForwarderCount: false, frameIngestionRate: true,
        uploadFrameRate: true, uploadSizeRate: false, transmitBatchSize: false,
        uploadResponsiveness: true, hoggingRate: false
    };

    // queuePressure va al índice 10, DESPUÉS de los datasets de umbral SET/RESET
    // (4-9, ver THRESHOLD_DATASET_INDEX) — insertarlo como dataset 4 correría
    // esos índices y los rompería; agregarlo al final evita tocarlos. queueUsage/
    // heapUsage/safForwarderCount son informativos (sin SLA/thresholds — solo
    // Pressure se monitorea; no hay alerting sobre SAF Forwarder Count), así
    // que van directo a continuación de los umbrales de Pressure (11-12), sin
    // necesitar sus propios slots de threshold.
    var METRIC_DATASET_INDEX = {
        cpu: 0, memory: 1, latency: 2, logPressure: 3, queuePressure: 10,
        queueUsage: 13, heapUsage: 14, safForwarderCount: 15, frameIngestionRate: 16,
        // SAF upload (agente → ingestion hub) — informativas, sin SLA/thresholds,
        // agregadas al final por la misma razón que las anteriores.
        uploadFrameRate: 17, uploadSizeRate: 18, transmitBatchSize: 19,
        uploadResponsiveness: 20, hoggingRate: 21
    };

    // Label shown in the "Show metrics" dropdown. No icons (2026-09-19): inside
    // md-option's own checkbox+label row, a second inline icon collided with
    // Angular Material's own selected-checkbox indicator (squished/overlapping
    // rendering) — dropped rather than fought.
    var METRIC_META = {
        cpu:               { label: 'CPU' },
        memory:            { label: 'Memory' },
        latency:           { label: 'Latency' },
        logPressure:       { label: 'Log Pressure' },
        queuePressure:     { label: 'Pressure' },
        queueUsage:        { label: 'Queue Usage' },
        heapUsage:         { label: 'Heap Usage' },
        safForwarderCount: { label: 'SAF Forwarder Count' },
        frameIngestionRate: { label: 'Avg Frame Ingestion Rate' },
        uploadFrameRate:   { label: 'Avg Upload Frame Rate' },
        uploadSizeRate:    { label: 'Avg Size Upload Rate' },
        transmitBatchSize: { label: 'Transmit Batch Size' },
        uploadResponsiveness: { label: 'Upload Responsiveness' },
        hoggingRate:       { label: 'Hogging Rate' }
    };

    $scope.toggleMetricVisibility = function (metric) {
        if (!chartInstance) return;
        chartInstance.setDatasetVisibility(
            METRIC_DATASET_INDEX[metric],
            $scope.metrics[metric]
        );
        chartInstance.update();
    };

    // Latency only applies to the aggregate "AGENT" view (ver ng-if en el
    // toggle de latencia) — se excluye del bulk select/clear cuando hay una
    // instancia puntual seleccionada, igual que el toggle individual.
    function visibleMetricKeys() {
        var keys = ['cpu', 'memory', 'logPressure', 'queuePressure', 'queueUsage', 'heapUsage', 'safForwarderCount', 'frameIngestionRate',
            'uploadFrameRate', 'uploadSizeRate', 'transmitBatchSize', 'uploadResponsiveness', 'hoggingRate'];
        if (!$scope.selectedPodName) keys.push('latency');
        return keys;
    }

    // ===== "Show metrics" dropdown (2026-09-19 — reemplaza la fila de
    // toggles individuales, uno por dimensión, por un md-select multiple:
    // con 7 dimensiones ya no entraba cómodo como una fila de chips) =====
    // selectedMetrics es la fuente de verdad que ve el dropdown; $scope.metrics
    // (flags por clave) se mantiene en paralelo porque el resto del controller
    // (hasAnyThresholdAvailable, los ng-if de cada threshold, applyMetricVisibility)
    // ya lo lee así — más simple mantener ambos sincronizados que reescribir esos
    // call sites contra un array.
    $scope.selectedMetrics = Object.keys($scope.metrics).filter(function (k) { return $scope.metrics[k]; });

    // metricOptions()/thresholdOptions() (below) are called every digest cycle
    // from ng-repeat — returning a fresh array of fresh {key,label,icon}
    // objects each time means the objects never have stable identity, so
    // ngRepeat's $watchCollection sees "changed" forever and Angular throws
    // $rootScope:infdig (10 iterations, never stabilizes). Cache by the
    // underlying key list and only rebuild the objects when it actually
    // changes, so the SAME array/object references come back otherwise.
    function arraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for (var i = 0; i < a.length; i++) {
            if (a[i] !== b[i]) return false;
        }
        return true;
    }

    var _metricOptionsCache = { keys: null, list: null };
    $scope.metricOptions = function () {
        var keys = visibleMetricKeys();
        if (_metricOptionsCache.keys && arraysEqual(_metricOptionsCache.keys, keys)) {
            return _metricOptionsCache.list;
        }
        var list = keys.map(function (k) {
            return { key: k, label: METRIC_META[k].label };
        });
        _metricOptionsCache = { keys: keys, list: list };
        return list;
    };

    // ===== DROPDOWN PANEL POSITIONING (Show metrics / SLA thresholds) =====
    //
    // Angular Material 1.2.2's md-select[multiple] centers its options panel
    // vertically around the FIRST *selected* option (see calculateMenuPositions
    // in select.js) rather than opening flush below the trigger — with several
    // options checked (our common case, since these both default to "all"),
    // the panel ends up floating away from the "Show metrics:" / "SLA
    // thresholds:" label it belongs to, sideways and/or overlapping content
    // above it. This version of the library has no md-position-mode-style flag
    // to opt out of that behavior (shouldOpenAroundTarget in select.js is
    // hardcoded false, dead code), so it's corrected here instead: remember
    // which <md-select> triggered the open (mousedown fires before Material's
    // own click-driven open logic), then watch for the panel it creates
    // (.metrics-dropdown-panel, appended directly under <body> per
    // Angular Material's `parent: 'body'`) and force it flush below that
    // trigger once it appears.
    //
    // Two-stage observer, not a single one reacting to the panel's insertion:
    // Material appends the (unstyled) panel synchronously, then positions it
    // — sets its top/left/transform — asynchronously afterward, via
    // $animateCss(...).start().then(positionAndFocusMenu). Reacting to the
    // panel merely being ADDED would run before that positioning call and get
    // clobbered a moment later. Instead, once the panel node shows up, a
    // second, one-shot observer watches ITS style attribute and overrides
    // top/left/transform the instant Material writes them.
    $scope.rememberDropdownTrigger = function ($event) {
        _lastDropdownTrigger = $event.currentTarget;
    };

    var _lastDropdownTrigger = null;
    var _dropdownPanelObserver = null;

    function repositionDropdownPanel(panelNode) {
        if (!_lastDropdownTrigger) return;
        var triggerRect = _lastDropdownTrigger.getBoundingClientRect();
        var desiredLeft = triggerRect.left;
        var maxLeft = window.innerWidth - panelNode.offsetWidth - 8;
        if (maxLeft > 0 && desiredLeft > maxLeft) desiredLeft = maxLeft;

        panelNode.style.transform = 'none';
        panelNode.style.top = (triggerRect.bottom + 4) + 'px';
        panelNode.style.left = Math.max(8, desiredLeft) + 'px';
    }

    if (typeof MutationObserver !== 'undefined') {
        _dropdownPanelObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
                    if (node.nodeType !== 1) return;
                    if (!node.classList || !node.classList.contains('metrics-dropdown-panel')) return;

                    var settled = false;
                    var styleObserver = new MutationObserver(function () {
                        if (settled) return;
                        settled = true;
                        styleObserver.disconnect();
                        repositionDropdownPanel(node);
                    });
                    styleObserver.observe(node, { attributes: true, attributeFilter: ['style'] });

                    // Material's positioning promise can resolve on the next
                    // frame rather than firing a style mutation this session
                    // ever sees (e.g. duration-0 animation edge cases) — a
                    // fallback timer guarantees the override still lands.
                    $timeout(function () {
                        if (settled) return;
                        settled = true;
                        styleObserver.disconnect();
                        repositionDropdownPanel(node);
                    }, 100);
                });
            });
        });
        _dropdownPanelObserver.observe(document.body, { childList: true });
    }

    $scope.onMetricsSelectionChanged = function () {
        Object.keys($scope.metrics).forEach(function (k) {
            $scope.metrics[k] = $scope.selectedMetrics.indexOf(k) !== -1;
        });
        applyMetricVisibility();
        if (chartInstance) chartInstance.update();
    };

    $scope.metricsSelectedSummary = function () {
        var total = visibleMetricKeys().length;
        var count = $scope.selectedMetrics.length;
        if (count === 0) return 'No metrics selected';
        if (count === total) return 'All metrics';
        return count + ' of ' + total + ' metrics';
    };

    $scope.hasAnyMetricSelected = function () {
        return visibleMetricKeys().some(function (k) { return $scope.metrics[k]; });
    };

    $scope.allMetricsSelected = function () {
        return visibleMetricKeys().every(function (k) { return $scope.metrics[k]; });
    };

    $scope.selectAllMetrics = function () {
        visibleMetricKeys().forEach(function (k) { $scope.metrics[k] = true; });
        $scope.selectedMetrics = visibleMetricKeys().slice();
        applyMetricVisibility();
        if (chartInstance) chartInstance.update();
    };

    $scope.clearAllMetrics = function () {
        visibleMetricKeys().forEach(function (k) { $scope.metrics[k] = false; });
        $scope.selectedMetrics = [];
        applyMetricVisibility();
        if (chartInstance) chartInstance.update();
    };

    function applyMetricVisibility() {
        if (!chartInstance) return;
        Object.keys($scope.metrics).forEach(function (metric) {
            chartInstance.setDatasetVisibility(
                METRIC_DATASET_INDEX[metric],
                $scope.metrics[metric]
            );
        });
    }

    // ===== THRESHOLD VISIBILITY =====

    $scope.thresholds = { cpu: false, memory: false, latency: false, pressure: false };

    // Corridos +1 respecto a antes: dataset 3 ahora es Log Pressure (ver
    // METRIC_DATASET_INDEX), así que los umbrales SET/RESET arrancan en 4.
    // pres-set/pres-reset van a 11/12, DESPUÉS del dataset 10 (Pressure, ver
    // METRIC_DATASET_INDEX) — no se insertan entre 4-9 para no correr esos
    // índices ya fijos.
    var THRESHOLD_DATASET_INDEX = {
        'cpu-set':   4,
        'cpu-reset': 5,
        'mem-set':   6,
        'mem-reset': 7,
        'lat-set':   8,
        'lat-reset': 9,
        'pres-set':   11,
        'pres-reset': 12
    };

    var THRESHOLD_PREFIX_MAP = { cpu: 'cpu', memory: 'mem', latency: 'lat', pressure: 'pres' };

    // Colores por métrica — coinciden con las líneas del chart
    var THRESHOLD_COLORS = {
        cpu:      { set: '#1565c0', reset: '#64b5f6' },
        memory:   { set: '#2e7d32', reset: '#81c784' },
        latency:  { set: '#e65100', reset: '#ffb74d' },
        pressure: { set: '#00695c', reset: '#4db6ac' }
    };

    $scope.hasAnyThresholdAvailable = function () {
        var mc = $scope.agent.monitoringConfig;
        if (!mc) return false;
        return (mc.cpu && mc.cpu.enabled) ||
            (mc.memory && mc.memory.enabled) ||
            (mc.latency && mc.latency.enabled) ||
            (mc.pressure && mc.pressure.enabled);
    };

    // Label for the "SLA thresholds" dropdown — same as the metric it shadows.
    // No icons, same reason as METRIC_META above. Latency excluded from
    // selectedPodName same as the metric list.
    var THRESHOLD_META = {
        cpu:      { label: 'CPU' },
        memory:   { label: 'Memory' },
        latency:  { label: 'Latency' },
        pressure: { label: 'Pressure' }
    };

    // Same condition each threshold toggle used to gate its own ng-if on:
    // its own SLA monitoring enabled AND its underlying metric line currently shown.
    function availableThresholdKeys() {
        var mc = $scope.agent.monitoringConfig || {};
        return Object.keys(THRESHOLD_META).filter(function (k) {
            if (k === 'latency' && $scope.selectedPodName) return false;
            return mc[k] && mc[k].enabled && $scope.metrics[k === 'pressure' ? 'queuePressure' : k];
        });
    }

    // ===== "SLA thresholds" dropdown (2026-09-19 — mismo tratamiento que el
    // dropdown de "Show metrics", por el mismo motivo: prolijidad) =====
    $scope.selectedThresholds = Object.keys($scope.thresholds).filter(function (k) { return $scope.thresholds[k]; });

    // Same infinite-digest hazard/fix as metricOptions() above.
    var _thresholdOptionsCache = { keys: null, list: null };
    $scope.thresholdOptions = function () {
        var keys = availableThresholdKeys();
        if (_thresholdOptionsCache.keys && arraysEqual(_thresholdOptionsCache.keys, keys)) {
            return _thresholdOptionsCache.list;
        }
        var list = keys.map(function (k) {
            return { key: k, label: THRESHOLD_META[k].label };
        });
        _thresholdOptionsCache = { keys: keys, list: list };
        return list;
    };

    $scope.onThresholdsSelectionChanged = function () {
        Object.keys($scope.thresholds).forEach(function (k) {
            $scope.thresholds[k] = $scope.selectedThresholds.indexOf(k) !== -1;
        });
        applyThresholdVisibility();
        if (chartInstance) chartInstance.update();
    };

    $scope.thresholdsSelectedSummary = function () {
        var total = availableThresholdKeys().length;
        var count = $scope.selectedThresholds.length;
        if (count === 0) return 'No thresholds selected';
        if (count === total) return 'All thresholds';
        return count + ' of ' + total + ' thresholds';
    };

    $scope.toggleThresholdVisibility = function (metric) {
        if (!chartInstance) return;
        var prefix = THRESHOLD_PREFIX_MAP[metric];
        var show = $scope.thresholds[metric];
        chartInstance.setDatasetVisibility(THRESHOLD_DATASET_INDEX[prefix + '-set'],   show);
        chartInstance.setDatasetVisibility(THRESHOLD_DATASET_INDEX[prefix + '-reset'], show);
        chartInstance.update();
    };

    function getThresholdLineData(yValue, fromTs, toTs) {
        return [
            { x: fromTs, y: yValue },
            { x: toTs,   y: yValue }
        ];
    }

    // Compartida por buildThresholdDatasets y buildPressureThresholdDatasets.
    function makeThresholdLine(fromTs, toTs, yValue, axisID, color, dashed, label) {
        return {
            label: label,
            data: getThresholdLineData(yValue, fromTs, toTs),
            borderColor: color,
            backgroundColor: 'transparent',
            borderWidth: dashed ? 1.5 : 2.5,
            borderDash: dashed ? [6, 4] : [],
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0,
            fill: false,
            tension: 0,
            yAxisID: axisID,
            hidden: true
        };
    }

    // ✅ MEJORADO: colores por métrica, SET sólido grueso, RESET punteado fino
    function buildThresholdDatasets(fromTs, toTs) {
        var mc      = $scope.agent.monitoringConfig || {};
        var cpu     = mc.cpu     || {};
        var memory  = mc.memory  || {};
        var latency = mc.latency || {};

        function makeLine(yValue, axisID, color, dashed, label) {
            return makeThresholdLine(fromTs, toTs, yValue, axisID, color, dashed, label);
        }

        return [
            makeLine((cpu.set    && cpu.set.threshold)    || 0, 'y-percentage', THRESHOLD_COLORS.cpu.set,     false, 'CPU SET threshold'),
            makeLine((cpu.reset  && cpu.reset.threshold)  || 0, 'y-percentage', THRESHOLD_COLORS.cpu.reset,   true,  'CPU RESET threshold'),
            makeLine((memory.set    && memory.set.threshold)    || 0, 'y-percentage', THRESHOLD_COLORS.memory.set,  false, 'Memory SET threshold'),
            makeLine((memory.reset  && memory.reset.threshold)  || 0, 'y-percentage', THRESHOLD_COLORS.memory.reset, true,  'Memory RESET threshold'),
            makeLine((latency.set    && latency.set.threshold)    || 0, 'y-latency',    THRESHOLD_COLORS.latency.set,  false, 'Latency SET threshold'),
            makeLine((latency.reset  && latency.reset.threshold)  || 0, 'y-latency',    THRESHOLD_COLORS.latency.reset, true,  'Latency RESET threshold')
        ];
    }

    // Umbrales SET/RESET de Pressure — construidos aparte (no dentro de
    // buildThresholdDatasets) para no correr los índices 4-9 ya fijos; se
    // agregan al final del array de datasets del chart, en 11/12 (después
    // del dataset 10, la línea de Pressure en sí — ver METRIC_DATASET_INDEX).
    function buildPressureThresholdDatasets(fromTs, toTs) {
        var mc = $scope.agent.monitoringConfig || {};
        var pressure = mc.pressure || {};

        return [
            makeThresholdLine(fromTs, toTs, (pressure.set   && pressure.set.threshold)   || 0, 'y-percentage', THRESHOLD_COLORS.pressure.set,   false, 'Pressure SET threshold'),
            makeThresholdLine(fromTs, toTs, (pressure.reset && pressure.reset.threshold) || 0, 'y-percentage', THRESHOLD_COLORS.pressure.reset, true,  'Pressure RESET threshold')
        ];
    }

    function applyThresholdVisibility() {
        if (!chartInstance) return;
        Object.keys($scope.thresholds).forEach(function (metric) {
            var prefix = THRESHOLD_PREFIX_MAP[metric];
            var show = $scope.thresholds[metric];
            chartInstance.setDatasetVisibility(THRESHOLD_DATASET_INDEX[prefix + '-set'],   show);
            chartInstance.setDatasetVisibility(THRESHOLD_DATASET_INDEX[prefix + '-reset'], show);
        });
    }

    function updateThresholdLineRanges(fromTs, toTs) {
        if (!chartInstance) return;
        Object.keys(THRESHOLD_DATASET_INDEX).forEach(function (key) {
            var ds = chartInstance.data.datasets[THRESHOLD_DATASET_INDEX[key]];
            if (ds && ds.data && ds.data.length === 2) {
                var yVal = ds.data[0].y;
                ds.data = getThresholdLineData(yVal, fromTs, toTs);
            }
        });
    }

    // ========================

    let chartInstance = null;
    let intervalChangeTimeout = null;
    let timeRangeChangeTimeout = null;

    // ✅ Configuración - CONVERTIR A SEGUNDOS
    const maxHistoryDays = ConfigurationService.getFromCache('frontend.agent.stats.max-metrics-history-window-days') || 30;

    const minIntervalSecs = Math.min(
        (ConfigurationService.getFromCache('frontend.agent.stats.min-metrics-aggregation-interval-mins') || 1) * 60,
        10
    );
    const maxIntervalSecs = (ConfigurationService.getFromCache('frontend.agent.stats.max-metrics-aggregation-interval-mins') || 60) * 60;
    const defaultIntervalSecs = (ConfigurationService.getFromCache('frontend.agent.stats.default-metrics-aggregation-interval-mins') || 15) * 60;
    const defaultPageSize = ConfigurationService.getFromCache('frontend.agent.stats.default-metrics-page-size') || 30;

    $scope.pageSize = defaultPageSize;

    console.log('⚙️ Configuration loaded:', {
        maxHistoryDays,
        minIntervalSecs,
        maxIntervalSecs,
        defaultIntervalSecs
    });

    const today = new Date();
    today.setHours(23, 59, 59, 999);
    const todayTimestamp = today.getTime();

    const maxDaysAgo = new Date();
    maxDaysAgo.setDate(maxDaysAgo.getDate() - maxHistoryDays);
    maxDaysAgo.setHours(0, 0, 0, 0);
    const maxDaysAgoTimestamp = maxDaysAgo.getTime();

    let actualMinTimestamp = null;
    let actualMaxTimestamp = null;

    const intervalRange = maxIntervalSecs - minIntervalSecs;
    const intervalStep = 10;

    console.log('⚙️ Interval slider config:', {
        min: minIntervalSecs,
        max: maxIntervalSecs,
        range: intervalRange,
        step: intervalStep,
        default: defaultIntervalSecs
    });

    // ===== TIME RANGE SLIDER =====

    $scope.timeRangeSlider = {
        minValue: maxDaysAgoTimestamp,
        maxValue: todayTimestamp,
        options: {
            floor: maxDaysAgoTimestamp,
            ceil: todayTimestamp,
            step: Math.round((todayTimestamp - maxDaysAgoTimestamp) * 0.01),
            minRange: Math.round((todayTimestamp - maxDaysAgoTimestamp) * 0.01),
            pushRange: true,
            draggableRange: false,
            showSelectionBar: true,
            noSwitching: true,
            enforceRange: true,
            enforceStep: false,
            disabled: true,

            translate: function (value, sliderId, label) {
                if (!value || value < 0 || !isFinite(value)) {
                    console.warn('⚠️ Invalid timestamp in slider:', value);
                    return 'Invalid date';
                }

                try {
                    const date = new Date(value);

                    if (isNaN(date.getTime())) {
                        console.warn('⚠️ Invalid date object:', value);
                        return 'Invalid date';
                    }

                    const sliderMin = $scope.timeRangeSlider.minValue || 0;
                    const sliderMax = $scope.timeRangeSlider.maxValue || Date.now();
                    const rangeDays = (sliderMax - sliderMin) / 86400000;

                    if (rangeDays < 2) {
                        return date.toLocaleString('en-US', {
                            month: 'short',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                        });
                    } else {
                        return date.toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric'
                        });
                    }
                } catch (error) {
                    console.error('❌ Error in translate function:', error);
                    return 'Error';
                }
            },

            onChange: function () {
                if (!$scope.timeRangeSlider.minValue || !$scope.timeRangeSlider.maxValue) {
                    return;
                }

                if ($scope.timeRangeSlider.minValue >= $scope.timeRangeSlider.maxValue) {
                    console.warn('⚠️ Invalid time range in onChange');
                    return;
                }

                try {
                    const from = new Date($scope.timeRangeSlider.minValue);
                    const to = new Date($scope.timeRangeSlider.maxValue);
                    const hours = (($scope.timeRangeSlider.maxValue - $scope.timeRangeSlider.minValue) / 1000 / 60 / 60).toFixed(1);
                    console.log('🎯 Time range dragging:', from.toISOString(), 'to', to.toISOString(), '(' + hours + ' hours)');
                } catch (error) {
                    console.error('❌ Error in onChange:', error);
                }
            },

            onEnd: function () {
                if (!$scope.timeRangeSlider.minValue || !$scope.timeRangeSlider.maxValue) {
                    console.warn('⚠️ Invalid time range, skipping onEnd');
                    return;
                }

                if ($scope.timeRangeSlider.minValue >= $scope.timeRangeSlider.maxValue) {
                    console.warn('⚠️ Invalid time range');
                    return;
                }

                console.log('✅ Time range released (MANUAL), loading data');
                triggerTimeRangeChangeFromSlider();
            }
        }
    };

    // ===== INTERVAL SLIDER =====

    $scope.intervalSlider = {
        value: defaultIntervalSecs,
        options: {
            floor: 10,
            ceil: maxIntervalSecs,
            step: intervalStep,
            enforceStep: true,
            showSelectionBar: true,

            translate: function (value) {
                if (value < 60) {
                    return value + 's';
                } else if (value < 3600) {
                    const mins = Math.round(value / 60);
                    return mins + (mins === 1 ? ' min' : ' mins');
                } else if (value < 86400) {
                    const hours = Math.round(value / 3600);
                    return hours + (hours === 1 ? ' hour' : ' hours');
                } else {
                    const days = Math.round(value / 86400);
                    return days + (days === 1 ? ' day' : ' days');
                }
            },

            onChange: function () {
                console.log('🎯 Interval dragging:', $scope.intervalSlider.value, 'seconds');
            },

            onEnd: function () {
                onIntervalChange();
            }
        }
    };

    console.log('📊 AgentStatsDialog initialized for:', $scope.agent.agentName || $scope.agent.agentId);

    $scope.onLiveModeChange = function () {
        console.log('🎚️ onLiveModeChange called, isLiveMode =', $scope.isLiveMode);

        $timeout(function () {
            console.log('⏱️ After timeout, isLiveMode =', $scope.isLiveMode);
            $scope.toggleLiveMode();
        }, 0);
    };

    // ===== INICIALIZAR RANGO DE TIEMPO DESDE BACKEND =====

    function initializeTimeRange() {
        console.log('🔍 Fetching actual time range from backend...');
        $scope.timeRangeLoading = true;

        TelemetryAgentService.getMetricsTimeRange($scope.agent.agentId, $scope.selectedPodName || 'AGENT', !!($scope.isLiveMode && chartInstance))
            .then(function (response) {
                const data = response.data;

                console.log('📅 Time range received:', data);

                if (!data.minTimestamp || !data.maxTimestamp ||
                    data.minTimestamp < 0 || data.maxTimestamp < 0 ||
                    data.minTimestamp >= data.maxTimestamp) {
                    console.error('❌ Invalid timestamps from backend:', data);
                    $scope.noDataMessage = 'Invalid time range data from server';
                    $scope.timeRangeLoading = false;
                    $scope.loading = false;
                    return;
                }

                actualMinTimestamp = data.minTimestamp;
                actualMaxTimestamp = data.maxTimestamp;

                console.log('✅ Actual range:', {
                    min: new Date(actualMinTimestamp).toISOString(),
                    max: new Date(actualMaxTimestamp).toISOString(),
                    daysSpan: ((actualMaxTimestamp - actualMinTimestamp) / 1000 / 60 / 60 / 24).toFixed(2)
                });

                $scope.timeRangeSlider.options.floor = actualMinTimestamp;
                $scope.timeRangeSlider.options.ceil = actualMaxTimestamp;

                const rangeMs = actualMaxTimestamp - actualMinTimestamp;
                const step = Math.max(60000, Math.round(rangeMs * 0.01));

                $scope.timeRangeSlider.options.step = step;
                $scope.timeRangeSlider.options.minRange = step;

                console.log('⚙️ Time slider step/minRange updated:', {
                    stepMs: step,
                    stepMins: (step / 60000).toFixed(1) + ' min',
                    minRangeMs: $scope.timeRangeSlider.options.minRange,
                    minRangeMins: ($scope.timeRangeSlider.options.minRange / 60000).toFixed(1) + ' min'
                });

                const oneHourMs = 60 * 60 * 1000;

                if (rangeMs > oneHourMs) {
                    $scope.timeRangeSlider.minValue = actualMaxTimestamp - oneHourMs;
                    $scope.timeRangeSlider.maxValue = actualMaxTimestamp;
                    $scope.activeTimePreset = 'hour';
                    console.log('📊 Initialized to Last Hour (default)');
                } else {
                    $scope.timeRangeSlider.minValue = actualMinTimestamp;
                    $scope.timeRangeSlider.maxValue = actualMaxTimestamp;
                    console.log('📊 Initialized to full available range (less than 1 hour of data)');
                }

                if ($scope.timeRangeSlider.minValue >= $scope.timeRangeSlider.maxValue) {
                    console.error('❌ Invalid slider values after initialization');
                    $scope.timeRangeSlider.minValue = actualMinTimestamp;
                    $scope.timeRangeSlider.maxValue = actualMaxTimestamp;
                }

                $scope.timeRangeSlider.options.disabled = false;

                $timeout(function () {
                    $scope.$broadcast('rzSliderForceRender');
                    $scope.timeRangeLoading = false;

                    $scope.page = 'LAST';
                    $scope.loadMetrics();
                }, 50);
            })
            .catch(function (error) {
                console.error('❌ Error fetching time range:', error);

                $scope.timeRangeLoading = false;
                $scope.loading = false;
                $scope.noDataMessage = 'Error loading time range. Please try again.';
            });
    }

    // ===== HELPER FUNCTIONS =====

    function getAgentSyncInterval() {
        const possibleFields = [
            'agentSyncInterval',
            'syncIntervalSecs',
            'syncInterval',
            'agentSyncIntervalSecs',
            'syncIntervalSeconds'
        ];

        for (let i = 0; i < possibleFields.length; i++) {
            const field = possibleFields[i];
            const value = $scope.agent[field];

            if (value !== undefined && value !== null) {
                const parsed = parseInt(value, 10);
                if (!isNaN(parsed) && parsed > 0) {
                    console.log('✅ Found agent sync interval in field "' + field + '":', parsed + 's');
                    return parsed;
                }
            }
        }

        console.warn('⚠️ No sync interval found in agent object, using default 20s');
        console.warn('⚠️ Available agent fields:', Object.keys($scope.agent).join(', '));
        return 20;
    }

    function getAvailableIntervals() {
        const rangeMs = $scope.timeRangeSlider.maxValue - $scope.timeRangeSlider.minValue;
        const rangeMinutes = rangeMs / (1000 * 60);
        const rangeHours = rangeMinutes / 60;
        const rangeDays = rangeHours / 24;

        console.log('📊 Time range duration:', {
            minutes: rangeMinutes.toFixed(2),
            hours: rangeHours.toFixed(2),
            days: rangeDays.toFixed(2)
        });

        let candidates;
        if (rangeMinutes <= 10) {
            console.log('✅ Range: ≤ 10min -> candidates: 10s, 1m, 5m');
            candidates = [10, 60, 300];
        } else if (rangeHours < 1) {
            console.log('✅ Range: 10min - 1h -> candidates: 10s, 1m, 5m, 15m, 30m');
            candidates = [10, 60, 300, 900, 1800];
        } else if (rangeHours <= 24) {
            console.log('✅ Range: 1h - 24h -> candidates: 1m, 5m, 15m, 30m, 1h');
            candidates = [60, 300, 900, 1800, 3600];
        } else if (rangeDays < 6.0) {
            console.log('✅ Range: 24h - 6 days -> candidates: 30m, 1h, 1d');
            candidates = [1800, 3600, 86400];
        } else {
            console.log('✅ Range: 6+ days -> candidates: 1m, 5m, 15m, 30m, 1h, 1d');
            candidates = [60, 300, 900, 1800, 3600, 86400];
        }

        // Filter by configured maximum — never offer an interval the backend won't accept
        const available = candidates.filter(function (s) { return s <= maxIntervalSecs; });

        // Safety: always keep at least one option (the smallest candidate)
        if (available.length === 0) {
            available.push(candidates[0]);
        }

        console.log('✅ Available intervals after config max filter (' + maxIntervalSecs + 's):', available);
        return available;
    }

    $scope.isIntervalAvailable = function (intervalSeconds) {
        if ($scope.isLiveMode) {
            const agentSyncIntervalSecs = getAgentSyncInterval();
            return intervalSeconds === agentSyncIntervalSecs;
        }

        const availableIntervals = getAvailableIntervals();
        return availableIntervals.includes(intervalSeconds);
    };

    function adjustIntervalIfNeeded() {
        const availableIntervals = getAvailableIntervals();

        if (!availableIntervals.includes($scope.intervalSlider.value)) {
            console.log('⚠️ Current interval', $scope.intervalSlider.value, 'sec not available for this time range');

            let closestInterval = availableIntervals[0];
            let minDiff = Math.abs($scope.intervalSlider.value - closestInterval);

            availableIntervals.forEach(function (interval) {
                const diff = Math.abs($scope.intervalSlider.value - interval);
                if (diff < minDiff) {
                    minDiff = diff;
                    closestInterval = interval;
                }
            });

            console.log('✅ Auto-adjusting interval to:', closestInterval + 'sec (' + (closestInterval / 60) + 'min)');
            $scope.intervalSlider.value = closestInterval;

            return true;
        }

        return false;
    }

    // ===== TOGGLE LIVE MODE =====

    $scope._savedIntervalSliderOptions = null;

    $scope.toggleLiveMode = function () {
        if ($scope._toggleInProgress) {
            console.log('⚠️ toggleLiveMode already in progress, skipping');
            return;
        }
        $scope._toggleInProgress = true;

        console.log('🔴 Live Mode toggled:', $scope.isLiveMode);

        if ($scope.isLiveMode) {
            console.log('▶️ Activating Live Monitoring mode');

            $scope.savedIntervalValue = $scope.intervalSlider.value;
            $scope.savedPageSize = $scope.pageSize;
            $scope.savedTimeRange = {
                min: $scope.timeRangeSlider.minValue,
                max: $scope.timeRangeSlider.maxValue
            };
            $scope.savedTimePreset = $scope.activeTimePreset;

            if (!$scope._savedIntervalSliderOptions) {
                $scope._savedIntervalSliderOptions = angular.copy($scope.intervalSlider.options);
            }

            console.log('💾 Saved configuration:', {
                interval: $scope.savedIntervalValue + ' seconds',
                pageSize: $scope.savedPageSize,
                timeRange: {
                    from: new Date($scope.savedTimeRange.min).toISOString(),
                    to: new Date($scope.savedTimeRange.max).toISOString()
                }
            });

            console.log('🔍 DEBUG BEFORE reading agentSyncInterval:');
            console.log('  - agent object:', $scope.agent);
            console.log('  - agent.agentSyncInterval:', $scope.agent.agentSyncInterval);
            console.log('  - typeof:', typeof $scope.agent.agentSyncInterval);

            const agentSyncIntervalSecs = $scope.agent.agentSyncInterval || 20;

            console.log('🔍 DEBUG AFTER evaluation:');
            console.log('  - Final value used:', agentSyncIntervalSecs);

            const minFloor = Math.min(10, agentSyncIntervalSecs);
            $scope.intervalSlider.options.floor = minFloor;

            const intervalStep = 1;
            $scope.intervalSlider.options.step = intervalStep;

            $scope.pageSize = LIVE_POINT_COUNT;

            const timeRangeMs = LIVE_POINT_COUNT * agentSyncIntervalSecs * 1000;

            console.log('⚡ Live Mode Configuration Applied:', {
                aggregationInterval: agentSyncIntervalSecs + 's',
                resolution: LIVE_POINT_COUNT + ' points',
                timeRangeDuration: (timeRangeMs / 1000 / 60).toFixed(2) + ' minutes',
                refreshInterval: agentSyncIntervalSecs + 's'
            });

            $scope.activeTimePreset = null;
            $scope.page = 0;

            if (actualMaxTimestamp && actualMaxTimestamp > 0) {
                const bucketMs = agentSyncIntervalSecs * 1000;
                const toTimestamp = Math.floor(actualMaxTimestamp / bucketMs) * bucketMs + bucketMs;
                const fromTimestamp = Math.max(actualMinTimestamp || 0, toTimestamp - timeRangeMs);

                if (fromTimestamp < toTimestamp && fromTimestamp >= 0 && toTimestamp > 0) {
                    $scope.timeRangeSlider.minValue = fromTimestamp;
                    $scope.timeRangeSlider.maxValue = toTimestamp;

                    const actualRangeMinutes = (toTimestamp - fromTimestamp) / 1000 / 60;

                    console.log('📅 Time range configured:', {
                        from: new Date(fromTimestamp).toISOString(),
                        to: new Date(toTimestamp).toISOString(),
                        targetDuration: (timeRangeMs / 1000 / 60).toFixed(2) + ' minutes',
                        actualDuration: actualRangeMinutes.toFixed(2) + ' minutes'
                    });
                } else {
                    console.error('❌ Invalid time range calculated:', { fromTimestamp, toTimestamp });
                }
            } else {
                console.warn('⚠️ No valid actualMaxTimestamp available, cannot set time range');
            }

            $timeout(function () {
                $scope.intervalSlider.value = agentSyncIntervalSecs;
                console.log('✅ Interval slider value set to:', agentSyncIntervalSecs + 's');

                $scope.$broadcast('rzSliderForceRender');

                $scope.timeRangeSlider.options.disabled = true;
                $scope.intervalSlider.options.disabled = true;

                $scope.$broadcast('rzSliderForceRender');

                $scope.loadMetrics();
                startLiveMonitoring();

                $scope._toggleInProgress = false;
            }, 0);

        } else {
            console.log('⏸️ Deactivating Live Monitoring mode');
            stopLiveMonitoring();

            $scope.timeRangeSlider.options.disabled = false;
            $scope.intervalSlider.options.disabled = false;

            if ($scope._savedIntervalSliderOptions) {
                $scope.intervalSlider.options = angular.copy($scope._savedIntervalSliderOptions);
                console.log('✅ Interval slider options restored');
            }

            if ($scope.savedIntervalValue !== undefined && $scope.savedIntervalValue !== null) {
                $scope.intervalSlider.value = $scope.savedIntervalValue;
                console.log('✅ Interval restored to:', $scope.savedIntervalValue + 's');
            }

            if ($scope.savedPageSize !== undefined && $scope.savedPageSize !== null) {
                $scope.pageSize = $scope.savedPageSize;
                console.log('✅ Page size restored to:', $scope.savedPageSize);
            }

            if ($scope.savedTimeRange) {
                $scope.timeRangeSlider.minValue = $scope.savedTimeRange.min;
                $scope.timeRangeSlider.maxValue = $scope.savedTimeRange.max;
                console.log('✅ Time range restored:', {
                    from: new Date($scope.savedTimeRange.min).toISOString(),
                    to: new Date($scope.savedTimeRange.max).toISOString()
                });
            }

            if ($scope.savedTimePreset !== undefined) {
                $scope.activeTimePreset = $scope.savedTimePreset;
                console.log('✅ Time preset restored:', $scope.savedTimePreset);
            }

            $timeout(function () {
                $scope.$broadcast('rzSliderForceRender');

                $scope.page = 0;
                $scope.loadMetrics();

                console.log('✅ Live Mode deactivated, returning to normal mode');
                $scope._toggleInProgress = false;
            }, 0);
        }
    };

    // ===== LIVE MONITORING FUNCTIONS =====

    function startLiveMonitoring() {
        const agentSyncIntervalSecs = getAgentSyncInterval();
        const configuredGrace = Number(ConfigurationService.getFromCache('frontend.agent.stats.live-mode-refresh-grace-seconds'));
        const graceSecs = Number.isFinite(configuredGrace) && configuredGrace >= 0 ? configuredGrace : 0;
        const refreshIntervalSecs = agentSyncIntervalSecs + graceSecs;
        $scope.liveRefreshIntervalSecs = refreshIntervalSecs;

        console.log('🔴 Starting Live Monitoring:', {
            agentId: $scope.agent.agentId,
            syncInterval: agentSyncIntervalSecs + 's',
            refreshInterval: refreshIntervalSecs + 's'
        });

        if (liveMonitoringInterval) {
            clearInterval(liveMonitoringInterval);
            liveMonitoringInterval = null;
            console.log('🧹 Cleared previous monitoring interval');
        }

        let tickCount = 0;

        liveMonitoringInterval = setInterval(function () {
            tickCount++;
            const elapsed = tickCount * refreshIntervalSecs;

            console.log('⏰ Live Monitoring tick #' + tickCount + ' (' + elapsed + 's elapsed)');

            if ($scope.isLiveMode) {
                console.log('🔄 Live Monitoring: Auto-refresh triggered');

                try {
                    $scope.$apply(function () {
                        $scope.loadMetrics();
                    });
                } catch (e) {
                    console.log('⚠️ Already in digest, calling loadMetrics directly');
                    $scope.loadMetrics();
                }
            } else {
                console.log('⚠️ Live Mode disabled, stopping interval');
                stopLiveMonitoring();
            }
        }, refreshIntervalSecs * 1000);

        console.log('✅ Live Monitoring interval started:', {
            intervalMs: (refreshIntervalSecs * 1000) + 'ms',
            intervalSecs: refreshIntervalSecs + 's'
        });
    }

    function stopLiveMonitoring() {
        if (chartInstance) LiveChartViewport.cancel(chartInstance);
        console.log('⏹️ Stopping Live Monitoring');

        if (liveMonitoringInterval) {
            clearInterval(liveMonitoringInterval);
            liveMonitoringInterval = null;
            console.log('✅ Live Monitoring interval cleared');
        }
    }

    // ===== PRESET FUNCTIONS =====

    $scope.hasCustomTimeRange = function () {
        if (!actualMinTimestamp || !actualMaxTimestamp) {
            return false;
        }
        return $scope.timeRangeSlider.minValue !== actualMinTimestamp ||
            $scope.timeRangeSlider.maxValue !== actualMaxTimestamp;
    };

    $scope.resetTimeRange = function () {
        if (!actualMinTimestamp || !actualMaxTimestamp) {
            console.warn('⚠️ Cannot reset: no actual range available');
            return;
        }

        $scope.timeRangeSlider.minValue = actualMinTimestamp;
        $scope.timeRangeSlider.maxValue = actualMaxTimestamp;
        $scope.activeTimePreset = null;

        $timeout(function () {
            $scope.$broadcast('rzSliderForceRender');
        }, 50);

        triggerTimeRangeChangeFromSlider();
    };

    $scope.setLast10MinPreset = function () {
        if (!actualMaxTimestamp) {
            console.warn('⚠️ Cannot set preset: no actual range available');
            return;
        }

        const toTimestamp = actualMaxTimestamp;
        const fromTimestamp = Math.max(actualMinTimestamp, toTimestamp - (10 * 60 * 1000));

        $scope.timeRangeSlider.minValue = fromTimestamp;
        $scope.timeRangeSlider.maxValue = toTimestamp;
        $scope.activeTimePreset = 'min';

        $timeout(function () {
            $scope.$broadcast('rzSliderForceRender');

            $timeout(function () {
                const intervalAdjusted = adjustIntervalIfNeeded();
                $scope.page = 'LAST';

                if (intervalAdjusted) {
                    $scope.$broadcast('rzSliderForceRender');
                    $timeout(function () {
                        triggerTimeRangeChangeFromPreset();
                    }, 100);
                } else {
                    triggerTimeRangeChangeFromPreset();
                }
            }, 100);
        }, 50);
    };

    $scope.setLastHourPreset = function () {
        if (!actualMaxTimestamp) {
            console.warn('⚠️ Cannot set preset: no actual range available');
            return;
        }

        const toTimestamp = actualMaxTimestamp;
        const fromTimestamp = Math.max(actualMinTimestamp, toTimestamp - (60 * 60 * 1000));

        $scope.timeRangeSlider.minValue = fromTimestamp;
        $scope.timeRangeSlider.maxValue = toTimestamp;
        $scope.activeTimePreset = 'hour';

        $timeout(function () {
            $scope.$broadcast('rzSliderForceRender');

            $timeout(function () {
                const intervalAdjusted = adjustIntervalIfNeeded();
                $scope.page = 'LAST';

                if (intervalAdjusted) {
                    $scope.$broadcast('rzSliderForceRender');
                    $timeout(function () {
                        triggerTimeRangeChangeFromPreset();
                    }, 100);
                } else {
                    triggerTimeRangeChangeFromPreset();
                }
            }, 100);
        }, 50);
    };

    $scope.setTimeRangePreset = function (days) {
        if (!actualMinTimestamp || !actualMaxTimestamp) {
            console.warn('⚠️ Cannot set preset: no actual range available');
            return;
        }

        let toTimestamp = actualMaxTimestamp;
        let fromTimestamp;

        if (days === 1) {
            fromTimestamp = Math.max(actualMinTimestamp, toTimestamp - (24 * 60 * 60 * 1000));
        } else {
            const toDate = new Date(toTimestamp);
            toDate.setHours(23, 59, 59, 999);

            const fromDate = new Date(toDate);
            fromDate.setDate(fromDate.getDate() - days);
            fromDate.setHours(0, 0, 0, 0);

            fromTimestamp = Math.max(actualMinTimestamp, fromDate.getTime());
            toTimestamp = Math.min(actualMaxTimestamp, toDate.getTime());
        }

        $scope.timeRangeSlider.minValue = fromTimestamp;
        $scope.timeRangeSlider.maxValue = toTimestamp;
        $scope.activeTimePreset = days;

        $timeout(function () {
            const intervalAdjusted = adjustIntervalIfNeeded();
            $scope.page = 'LAST';

            if (intervalAdjusted) {
                $scope.$broadcast('rzSliderForceRender');
                $timeout(function () {
                    triggerTimeRangeChangeFromPreset();
                }, 100);
            } else {
                triggerTimeRangeChangeFromPreset();
            }
        }, 0);
    };

    function triggerTimeRangeChangeFromPreset() {
        if (timeRangeChangeTimeout) {
            $timeout.cancel(timeRangeChangeTimeout);
        }

        $scope.isChangingInterval = true;

        timeRangeChangeTimeout = $timeout(function () {
            if ($scope.page !== 'LAST') {
                $scope.page = 0;
            }
            $scope.loadMetrics();
        }, 500);
    }

    function triggerTimeRangeChangeFromSlider() {
        if (timeRangeChangeTimeout) {
            $timeout.cancel(timeRangeChangeTimeout);
        }

        $scope.isChangingInterval = true;
        $scope.activeTimePreset = null;

        const intervalAdjusted = adjustIntervalIfNeeded();

        timeRangeChangeTimeout = $timeout(function () {
            $scope.page = 0;

            if (intervalAdjusted) {
                $scope.$broadcast('rzSliderForceRender');
                $timeout(function () {
                    $scope.loadMetrics();
                }, 100);
            } else {
                $scope.loadMetrics();
            }
        }, 500);
    }

    $scope.setIntervalPreset = function (seconds) {
        if (!$scope.isIntervalAvailable(seconds)) {
            console.log('⚠️ Interval', seconds, 'sec is not available for current time range');
            return;
        }

        let effectiveSeconds = (seconds === 86400)
            ? 86400
            : Math.max(minIntervalSecs, Math.min(seconds, maxIntervalSecs));

        const step = ($scope.intervalSlider && $scope.intervalSlider.options && $scope.intervalSlider.options.step) ? $scope.intervalSlider.options.step : 10;
        effectiveSeconds = Math.round(effectiveSeconds / step) * step;

        const floor = ($scope.intervalSlider && $scope.intervalSlider.options && $scope.intervalSlider.options.floor) ? $scope.intervalSlider.options.floor : 10;
        if (effectiveSeconds < floor) effectiveSeconds = floor;

        if ($scope.intervalSlider.value === effectiveSeconds) {
            console.log('ℹ️ Interval already set to', effectiveSeconds, 'seconds');
            return;
        }

        console.log('⏱️ Setting interval to:', effectiveSeconds + 'sec (' + (effectiveSeconds / 60) + 'min)');
        $scope.intervalSlider.value = effectiveSeconds;
        $scope.isChangingInterval = true;

        $timeout(function () {
            $scope.$broadcast('rzSliderForceRender');
            console.log('✅ Slider refreshed. New value:', $scope.intervalSlider.value);

            $timeout(function () {
                $scope.isChangingInterval = false;
            }, 0);
        }, 0);

        if (intervalChangeTimeout) {
            $timeout.cancel(intervalChangeTimeout);
        }

        $scope.page = 0;
        $scope.loadMetrics();
    };

    function onIntervalChange() {
        console.log('🎚️ Interval changed to:', $scope.intervalSlider.value, 'seconds');

        if (intervalChangeTimeout) {
            $timeout.cancel(intervalChangeTimeout);
        }

        $scope.isChangingInterval = true;

        intervalChangeTimeout = $timeout(function () {
            $scope.page = 0;
            $scope.loadMetrics();
        }, 300);
    }

    // ===== DATA LOADING =====

    $scope.loadMetrics = function () {
        $scope.isLoadingChart = !($scope.isLiveMode && chartInstance);
        $scope.noDataMessage = '';

        const hasLastPreset = $scope.activeTimePreset !== null &&
            $scope.activeTimePreset !== undefined &&
            ['min', 'hour', 1, 7, 14, 30].includes($scope.activeTimePreset);

        if (hasLastPreset || $scope.isLiveMode) {
            console.log('📅 Active preset or Live Mode - Recalculating time window...');

            TelemetryAgentService.getMetricsTimeRange($scope.agent.agentId, $scope.selectedPodName || 'AGENT', !!($scope.isLiveMode && chartInstance))
                .then(function (response) {
                    const data = response.data;

                    if (data.maxTimestamp) {
                        actualMaxTimestamp = data.maxTimestamp;

                        // API buckets are half-open: ending at maxTimestamp drops
                        // the newest sample. Use stable bucket boundaries so each
                        // refresh includes it and preserves timestamp identity.
                        const bucketMs = getAgentSyncInterval() * 1000;
                        const toTimestamp = $scope.isLiveMode
                            ? Math.floor(actualMaxTimestamp / bucketMs) * bucketMs + bucketMs
                            : actualMaxTimestamp;
                        let fromTimestamp;

                        if ($scope.isLiveMode) {
                            const agentSyncIntervalSecs = getAgentSyncInterval();
                            const timeRangeMs = LIVE_POINT_COUNT * agentSyncIntervalSecs * 1000;
                            fromTimestamp = Math.max(actualMinTimestamp || 0, toTimestamp - timeRangeMs);

                            console.log('🔴 Live Mode time range calculated:', {
                                syncInterval: agentSyncIntervalSecs + 's',
                                points: LIVE_POINT_COUNT,
                                from: new Date(fromTimestamp).toISOString(),
                                to: new Date(toTimestamp).toISOString()
                            });
                        } else if ($scope.activeTimePreset === 'min') {
                            fromTimestamp = Math.max(actualMinTimestamp, toTimestamp - (10 * 60 * 1000));
                        } else if ($scope.activeTimePreset === 'hour') {
                            fromTimestamp = Math.max(actualMinTimestamp, toTimestamp - (60 * 60 * 1000));
                        } else if ($scope.activeTimePreset === 1) {
                            fromTimestamp = Math.max(actualMinTimestamp, toTimestamp - (24 * 60 * 60 * 1000));
                        } else if ($scope.activeTimePreset === 7) {
                            const toDate = new Date(toTimestamp);
                            toDate.setHours(23, 59, 59, 999);
                            const fromDate = new Date(toDate);
                            fromDate.setDate(fromDate.getDate() - 7);
                            fromDate.setHours(0, 0, 0, 0);
                            fromTimestamp = Math.max(actualMinTimestamp, fromDate.getTime());
                        } else if ($scope.activeTimePreset === 14) {
                            const toDate = new Date(toTimestamp);
                            toDate.setHours(23, 59, 59, 999);
                            const fromDate = new Date(toDate);
                            fromDate.setDate(fromDate.getDate() - 14);
                            fromDate.setHours(0, 0, 0, 0);
                            fromTimestamp = Math.max(actualMinTimestamp, fromDate.getTime());
                        } else if ($scope.activeTimePreset === 30) {
                            const toDate = new Date(toTimestamp);
                            toDate.setHours(23, 59, 59, 999);
                            const fromDate = new Date(toDate);
                            fromDate.setDate(fromDate.getDate() - 30);
                            fromDate.setHours(0, 0, 0, 0);
                            fromTimestamp = Math.max(actualMinTimestamp, fromDate.getTime());
                        }

                        if (!fromTimestamp || fromTimestamp < 0 || fromTimestamp >= toTimestamp) {
                            console.error('❌ Invalid fromTimestamp calculated:', {
                                fromTimestamp,
                                toTimestamp,
                                isLiveMode: $scope.isLiveMode
                            });
                            fromTimestamp = Math.max(actualMinTimestamp || 0, toTimestamp - ($scope.isLiveMode ? LIVE_POINT_COUNT * getAgentSyncInterval() * 1000 : (60 * 60 * 1000)));
                            console.warn('⚠️ Using fallback fromTimestamp:', fromTimestamp);
                        }

                        $scope.timeRangeSlider.minValue = fromTimestamp;
                        $scope.timeRangeSlider.maxValue = toTimestamp;
                        $scope.timeRangeSlider.options.ceil = toTimestamp;

                        $timeout(function () {
                            $scope.$broadcast('rzSliderForceRender');
                        }, 50);
                    }

                    loadMetricsInternal();
                })
                .catch(function (error) {
                    console.error('❌ Error updating time range:', error);
                    loadMetricsInternal();
                });
        } else {
            console.log('📅 Custom time range, using slider values directly');
            loadMetricsInternal();
        }
    };

    function loadMetricsInternal() {
        const startTs = $scope.timeRangeSlider.minValue;
        const endTs = $scope.timeRangeSlider.maxValue;
        const intervalSeconds = $scope.intervalSlider.value;

        const wantsLastPage = $scope.page === 'LAST';
        const requestPage = wantsLastPage ? 0 : $scope.page;

        console.log('📤 Loading aggregated metrics:');
        console.log('  - Start:', new Date(startTs).toISOString());
        console.log('  - End:', new Date(endTs).toISOString());
        console.log('  - Interval:', intervalSeconds, 'seconds');
        console.log('  - Page:', requestPage, '(wants last:', wantsLastPage + ')');
        console.log('  - Page Size:', $scope.pageSize);
        console.log('  - Is Live Mode:', $scope.isLiveMode);

        if (!startTs || !endTs || startTs < 0 || endTs < 0) {
            console.error('❌ Invalid timestamps:', { startTs, endTs });
            $scope.noDataMessage = 'Invalid time range';
            $scope.isLoadingChart = false;
            $scope.isChangingInterval = false;
            $scope.loading = false;
            return;
        }

        if (startTs >= endTs) {
            console.error('❌ Invalid time range: startTs >= endTs', { startTs, endTs });
            $scope.noDataMessage = 'Invalid time range';
            $scope.isLoadingChart = false;
            $scope.isChangingInterval = false;
            $scope.loading = false;
            return;
        }

        TelemetryAgentService.getAggregatedMetrics(
            $scope.agent.agentId,
            startTs,
            endTs,
            intervalSeconds,
            requestPage,
            $scope.pageSize,
            $scope.selectedPodName || 'AGENT', !!($scope.isLiveMode && chartInstance)
        )
            .then(function (response) {
                if (response.status === 204) {
                    console.log('ℹ️ No data available (204 No Content)');
                    $scope.noDataMessage = 'No metrics available for this time range';
                    $scope.aggregatedData = [];
                    $scope.totalPages = 0;
                    $scope.totalIntervals = 0;
                    $scope.page = 0;
                    $scope.loading = false;
                    $scope.isLoadingChart = false;
                    $scope.isChangingInterval = false;
                    return;
                }

                if (response.data && response.data.success) {
                    $scope.totalPages = response.data.totalPages || 0;
                    $scope.totalIntervals = response.data.totalElements || 0;

                    if (wantsLastPage && $scope.totalPages > 0) {
                        const lastPage = $scope.totalPages - 1;
                        $scope.page = lastPage;

                        TelemetryAgentService.getAggregatedMetrics(
                            $scope.agent.agentId,
                            startTs,
                            endTs,
                            intervalSeconds,
                            lastPage,
                            $scope.pageSize,
                            $scope.selectedPodName || 'AGENT', !!($scope.isLiveMode && chartInstance)
                        )
                            .then(function (lastPageResponse) {
                                if (lastPageResponse.status === 204) {
                                    console.log('ℹ️ No data on last page (204 No Content)');
                                    $scope.noDataMessage = 'No metrics available';
                                    $scope.aggregatedData = [];
                                    return;
                                }

                                if (lastPageResponse.data && lastPageResponse.data.success) {
                                    $scope.aggregatedData = lastPageResponse.data.data || [];

                                    if ($scope.aggregatedData.length > 0) {
                                        $scope.renderChart();
                                    } else {
                                        $scope.noDataMessage = 'No metrics found';
                                    }
                                }
                            })
                            .catch(function (error) {
                                console.error('❌ Error fetching last page:', error);
                                $scope.noDataMessage = 'Error loading metrics';
                                $scope.aggregatedData = [];
                            })
                            .finally(function () {
                                $scope.loading = false;
                                $scope.isLoadingChart = false;
                                $scope.isChangingInterval = false;
                                $timeout(function () {
                                    $scope.$broadcast('rzSliderForceRender');
                                }, 100);
                            });
                    } else {
                        $scope.aggregatedData = response.data.data || [];

                        if (wantsLastPage) {
                            $scope.page = 0;
                        }

                        if ($scope.aggregatedData.length > 0) {
                            $scope.renderChart();
                        } else {
                            $scope.noDataMessage = 'No metrics found';
                        }

                        $scope.loading = false;
                        $scope.isLoadingChart = false;
                        $scope.isChangingInterval = false;

                        $timeout(function () {
                            $scope.$broadcast('rzSliderForceRender');
                        }, 100);
                    }
                } else {
                    $scope.noDataMessage = 'No metrics available';
                    $scope.aggregatedData = [];
                    $scope.totalIntervals = 0;
                    $scope.totalPages = 0;
                    $scope.page = 0;
                }
            })
            .catch(function (error) {
                console.error('❌ Error fetching metrics:', error);

                if (error.status === 204) {
                    $scope.noDataMessage = 'No metrics available for this time range';
                } else {
                    $scope.noDataMessage = 'Error loading metrics';
                }

                $scope.aggregatedData = [];
                $scope.totalIntervals = 0;
                $scope.totalPages = 0;
                $scope.page = 0;
            })
            .finally(function () {
                if (!wantsLastPage || $scope.totalPages === 0) {
                    $scope.loading = false;
                    $scope.isLoadingChart = false;
                    $scope.isChangingInterval = false;
                    $timeout(function () {
                        $scope.$broadcast('rzSliderForceRender');
                    }, 100);
                }
            });
    }

    // ===== PAGINATION =====

    $scope.firstPage = function () {
        if ($scope.page !== 0) {
            $scope.page = 0;
            $scope.loadMetrics();
        }
    };

    $scope.lastPage = function () {
        if ($scope.page < $scope.totalPages - 1) {
            $scope.page = $scope.totalPages - 1;
            $scope.loadMetrics();
        }
    };

    $scope.nextPage = function () {
        if ($scope.page < $scope.totalPages - 1) {
            $scope.page++;
            $scope.loadMetrics();
        }
    };

    $scope.prevPage = function () {
        if ($scope.page > 0) {
            $scope.page--;
            $scope.loadMetrics();
        }
    };

    $scope.changePageSize = function (newSize) {
        if ($scope.pageSize === newSize) return;
        $scope.pageSize = newSize;
        $scope.page = 0;
        $scope.loadMetrics();
    };

    // ===== CHART RENDERING =====

    function getLatestTimestampFromSeries(seriesList, fallbackTs) {
        let latest = null;
        seriesList.forEach(function (arr) {
            if (arr && arr.length) {
                for (let i = 0; i < arr.length; i++) {
                    const x = arr[i].x;
                    if (latest === null || x > latest) latest = x;
                }
            }
        });
        return (latest !== null) ? latest : fallbackTs;
    }

    function applyRealSlidingWindow(chart, windowMs, nowTs) {
        const fromTs = nowTs - windowMs;

        chart.data.datasets.forEach(function (ds) {
            if (!ds.data || !ds.data.length) return;
            ds.data = ds.data.filter(function (p) {
                return p.x >= fromTs && p.x <= nowTs;
            });
        });

        chart.options.scales.x.min = fromTs;
        chart.options.scales.x.max = nowTs;
    }

    function setHoverOnlyPoints(chart) {
        chart.data.datasets.forEach(function (ds) {
            ds.pointRadius = 0;
            ds.pointHoverRadius = 5;
            ds.pointHitRadius = 10;
        });
    }

    $scope.renderChart = function () {
        if ($scope.isLiveMode && chartInstance && !skipLiveCaptureOnce) LiveChartViewport.capture(chartInstance);
        skipLiveCaptureOnce = false;
        const canvas = document.getElementById('agentMetricsChart');
        if (!canvas) {
            $timeout($scope.renderChart, 100);
            return;
        }

        const container = canvas.parentElement;
        if (!container || container.offsetParent === null) {
            $timeout($scope.renderChart, 100);
            return;
        }

        const ctx = canvas.getContext('2d');

        if (!$scope.isLiveMode) {
            const existingChart = Chart.getChart('agentMetricsChart');
            if (existingChart) {
                existingChart.destroy();
                chartInstance = null;
            }
        }

        const cpuData = [];
        const memData = [];
        const latencyData = [];
        const logPressureData = [];
        const queuePressureData = [];
        const queueUsageData = [];
        const heapUsageData = [];
        const safForwarderCountData = [];
        const frameIngestionRateData = [];
        const uploadFrameRateData = [];
        const uploadSizeRateData = [];
        const transmitBatchSizeData = [];
        const uploadResponsivenessData = [];
        const hoggingRateData = [];

        $scope.aggregatedData.forEach(function (interval) {
            const timestamp = new Date(interval.intervalStart).getTime();
            if (interval.avgCpu !== null)           cpuData.push({ x: timestamp, y: interval.avgCpu });
            if (interval.avgMem !== null)           memData.push({ x: timestamp, y: interval.avgMem });
            if (interval.avgLatency !== null)       latencyData.push({ x: timestamp, y: interval.avgLatency });
            if (interval.avgLogPressure !== null)   logPressureData.push({ x: timestamp, y: interval.avgLogPressure });
            if (interval.avgQueuePressure !== null) queuePressureData.push({ x: timestamp, y: interval.avgQueuePressure });
            if (interval.avgQueueUsage !== null)    queueUsageData.push({ x: timestamp, y: interval.avgQueueUsage });
            if (interval.avgHeapUsage !== null)     heapUsageData.push({ x: timestamp, y: interval.avgHeapUsage });
            if (Number.isFinite(interval.avgIngestedFramesPerMin)) frameIngestionRateData.push({ x: timestamp, y: interval.avgIngestedFramesPerMin });
            if (interval.avgSafForwarderCount !== null) safForwarderCountData.push({ x: timestamp, y: interval.avgSafForwarderCount });
            if (Number.isFinite(interval.avgUploadedFramesPerMin)) uploadFrameRateData.push({ x: timestamp, y: interval.avgUploadedFramesPerMin });
            if (Number.isFinite(interval.avgUploadRateKbMin)) uploadSizeRateData.push({ x: timestamp, y: interval.avgUploadRateKbMin });
            if (Number.isFinite(interval.avgTransmitBatchSize)) transmitBatchSizeData.push({ x: timestamp, y: interval.avgTransmitBatchSize });
            if (Number.isFinite(interval.avgUploadResponsiveness)) uploadResponsivenessData.push({ x: timestamp, y: interval.avgUploadResponsiveness });
            if (Number.isFinite(interval.avgHoggingRate)) hoggingRateData.push({ x: timestamp, y: interval.avgHoggingRate });
        });

        // Calcular rango real desde los datos para no comprimir el eje X
        const metricSeries = {
            cpu: cpuData, memory: memData, latency: latencyData, logPressure: logPressureData,
            queuePressure: queuePressureData, queueUsage: queueUsageData, heapUsage: heapUsageData,
            safForwarderCount: safForwarderCountData, frameIngestionRate: frameIngestionRateData,
            uploadFrameRate: uploadFrameRateData, uploadSizeRate: uploadSizeRateData,
            transmitBatchSize: transmitBatchSizeData, uploadResponsiveness: uploadResponsivenessData,
            hoggingRate: hoggingRateData
        };
        const allPoints = Object.keys(metricSeries)
            .filter(function (key) { return !$scope.isLiveMode || $scope.metrics[key]; })
            .reduce(function (points, key) { return points.concat(metricSeries[key]); }, []);
        const dataMinX = allPoints.length
            ? allPoints.reduce(function (min, p) { return p.x < min ? p.x : min; }, allPoints[0].x)
            : $scope.timeRangeSlider.minValue;
        const dataMaxX = allPoints.length
            ? allPoints.reduce(function (max, p) { return p.x > max ? p.x : max; }, allPoints[0].x)
            : $scope.timeRangeSlider.maxValue;

        function getTimeUnit(intervalSeconds) {
            if (intervalSeconds < 60) return 'second';
            const intervalMinutes = intervalSeconds / 60;
            if (intervalMinutes <= 5)  return 'minute';
            if (intervalMinutes <= 60) return 'hour';
            return 'day';
        }

        function getMaxTicksLimit(dataCount, intervalSeconds) {
            const intervalMinutes = intervalSeconds / 60;
            if (dataCount <= 10) return dataCount;
            if (intervalMinutes <= 5)  return Math.min(dataCount, 25);
            if (intervalMinutes <= 30) return Math.min(dataCount, 40);
            if (dataCount <= 50) return dataCount;
            return 40;
        }

        const intervalSeconds = $scope.intervalSlider.value;
        const timeUnit = getTimeUnit(intervalSeconds);
        const maxTicks = getMaxTicksLimit($scope.aggregatedData.length, intervalSeconds);

        // ── UPDATE PATH (chart ya existe) ──
        if (chartInstance) {
            chartInstance.data.datasets[0].data = cpuData;
            chartInstance.data.datasets[1].data = memData;
            chartInstance.data.datasets[2].data = latencyData;
            chartInstance.data.datasets[3].data = logPressureData;
            chartInstance.data.datasets[10].data = queuePressureData;
            chartInstance.data.datasets[13].data = queueUsageData;
            chartInstance.data.datasets[14].data = heapUsageData;
            chartInstance.data.datasets[15].data = safForwarderCountData;
            chartInstance.data.datasets[16].data = frameIngestionRateData;
            chartInstance.data.datasets[17].data = uploadFrameRateData;
            chartInstance.data.datasets[18].data = uploadSizeRateData;
            chartInstance.data.datasets[19].data = transmitBatchSizeData;
            chartInstance.data.datasets[20].data = uploadResponsivenessData;
            chartInstance.data.datasets[21].data = hoggingRateData;
            chartInstance.options.scales.x.time.unit = timeUnit;
            chartInstance.options.scales.x.ticks.maxTicksLimit = maxTicks;

            setHoverOnlyPoints(chartInstance);
            updateThresholdLineRanges(dataMinX, dataMaxX);
            applyMetricVisibility();
            applyThresholdVisibility();

            if ($scope.isLiveMode) {
                if (typeof chartInstance.setActiveElements === 'function') {
                    chartInstance.setActiveElements([]);
                }
                if (chartInstance.tooltip && typeof chartInstance.tooltip.setActiveElements === 'function') {
                    chartInstance.tooltip.setActiveElements([], { x: 0, y: 0 });
                }

                LiveChartViewport.slide(chartInstance, dataMinX, dataMaxX);
            } else {
                chartInstance.options.scales.x.min = undefined;
                chartInstance.options.scales.x.max = undefined;
                chartInstance.options.animation = { duration: 0 };
                chartInstance.update('none');
            }

            return;
        }

        // ── CREATE PATH (chart nuevo) ──
        try {

            // ✅ NUEVO: plugin que dibuja etiquetas inline sobre cada línea de threshold
            var thresholdLabelPlugin = {
                id: 'thresholdLabels',
                afterDraw: function (chart) {
                    var c = chart.ctx;
                    chart.data.datasets.forEach(function (ds, i) {
                        if (!ds.label || !ds.label.includes('threshold')) return;
                        var meta = chart.getDatasetMeta(i);
                        if (meta.hidden) return;
                        if (!ds.data || ds.data.length < 2) return;

                        var yAxis = chart.scales[ds.yAxisID];
                        if (!yAxis) return;

                        var yVal     = ds.data[0].y;
                        var yPos     = yAxis.getPixelForValue(yVal);
                        var xPos     = chart.chartArea.right - 6;
                        var labelTxt = ds.label.replace(' threshold', '');

                        c.save();
                        c.font = 'bold 10px Roboto, sans-serif';
                        var textW = c.measureText(labelTxt).width;

                        // fondo semitransparente
                        c.fillStyle = 'rgba(255, 255, 255, 0.88)';
                        c.beginPath();
                        c.roundRect
                            ? c.roundRect(xPos - textW - 8, yPos - 9, textW + 10, 16, 3)
                            : c.rect(xPos - textW - 8, yPos - 9, textW + 10, 16);
                        c.fill();

                        // texto coloreado
                        c.fillStyle    = ds.borderColor;
                        c.textAlign    = 'right';
                        c.textBaseline = 'middle';
                        c.fillText(labelTxt, xPos, yPos);
                        c.restore();
                    });
                }
            };

            chartInstance = new Chart(ctx, {
                plugins: [thresholdLabelPlugin],
                type: 'line',
                data: {
                    datasets: [
                        // ── dataset 0: CPU ──
                        {
                            label: 'Avg CPU (%)',
                            data: cpuData,
                            borderColor: '#2196f3',
                            backgroundColor: 'rgba(33, 150, 243, 0.1)',
                            pointBackgroundColor: '#2196f3',
                            pointBorderColor: '#2196f3',
                            pointRadius: 0,
                            pointHoverRadius: 5,
                            pointHitRadius: 10,
                            borderJoinStyle: 'bevel',
                            borderCapStyle: 'butt',
                            borderWidth: 2,
                            fill: true,
                            tension: 0.4,
                            yAxisID: 'y-percentage'
                        },
                        // ── dataset 1: Memory ──
                        {
                            label: 'Avg Memory (%)',
                            data: memData,
                            borderColor: '#4caf50',
                            backgroundColor: 'rgba(76, 175, 80, 0.1)',
                            pointBackgroundColor: '#4caf50',
                            pointBorderColor: '#4caf50',
                            pointRadius: 0,
                            pointHoverRadius: 5,
                            pointHitRadius: 10,
                            borderJoinStyle: 'bevel',
                            borderCapStyle: 'butt',
                            borderWidth: 2,
                            fill: true,
                            tension: 0.4,
                            yAxisID: 'y-percentage'
                        },
                        // ── dataset 2: Latency ──
                        {
                            label: 'Avg Latency (ms)',
                            data: latencyData,
                            borderColor: '#ff9800',
                            backgroundColor: 'rgba(255, 152, 0, 0.1)',
                            pointBackgroundColor: '#ff9800',
                            pointBorderColor: '#ff9800',
                            pointRadius: 0,
                            pointHoverRadius: 5,
                            pointHitRadius: 10,
                            borderJoinStyle: 'bevel',
                            borderCapStyle: 'butt',
                            borderWidth: 2,
                            fill: true,
                            tension: 0.4,
                            yAxisID: 'y-latency'
                        },
                        // ── dataset 3: Log Pressure ── (mismo eje 0-100% que CPU/Memory)
                        {
                            label: 'Avg Log Pressure (%)',
                            data: logPressureData,
                            borderColor: '#9c27b0',
                            backgroundColor: 'rgba(156, 39, 176, 0.1)',
                            pointBackgroundColor: '#9c27b0',
                            pointBorderColor: '#9c27b0',
                            pointRadius: 0,
                            pointHoverRadius: 5,
                            pointHitRadius: 10,
                            borderJoinStyle: 'bevel',
                            borderCapStyle: 'butt',
                            borderWidth: 2,
                            fill: true,
                            tension: 0.4,
                            yAxisID: 'y-percentage'
                        },
                        // ── datasets 4-9: SLA threshold lines ──
                        ...buildThresholdDatasets(dataMinX, dataMaxX),
                        // ── dataset 10: Pressure (queue/disk-buffer pressure) ── (mismo eje 0-100% que CPU/Memory/Log Pressure)
                        {
                            label: 'Avg Pressure (%)',
                            data: queuePressureData,
                            borderColor: '#00897b',
                            backgroundColor: 'rgba(0, 137, 123, 0.1)',
                            pointBackgroundColor: '#00897b',
                            pointBorderColor: '#00897b',
                            pointRadius: 0,
                            pointHoverRadius: 5,
                            pointHitRadius: 10,
                            borderJoinStyle: 'bevel',
                            borderCapStyle: 'butt',
                            borderWidth: 2,
                            fill: true,
                            tension: 0.4,
                            yAxisID: 'y-percentage'
                        },
                        // ── datasets 11-12: Pressure SLA threshold lines ──
                        ...buildPressureThresholdDatasets(dataMinX, dataMaxX),
                        // ── dataset 13: Queue Usage ── (uno de los dos factores de Pressure — informativo, sin SLA/thresholds)
                        {
                            label: 'Avg Queue Usage (%)',
                            data: queueUsageData,
                            borderColor: '#5e35b1',
                            backgroundColor: 'rgba(94, 53, 177, 0.1)',
                            pointBackgroundColor: '#5e35b1',
                            pointBorderColor: '#5e35b1',
                            pointRadius: 0,
                            pointHoverRadius: 5,
                            pointHitRadius: 10,
                            borderJoinStyle: 'bevel',
                            borderCapStyle: 'butt',
                            borderWidth: 2,
                            fill: true,
                            tension: 0.4,
                            yAxisID: 'y-percentage'
                        },
                        // ── dataset 14: Heap Usage ── (el otro factor de Pressure — informativo, sin SLA/thresholds)
                        {
                            label: 'Avg Heap Usage (%)',
                            data: heapUsageData,
                            borderColor: '#d81b60',
                            backgroundColor: 'rgba(216, 27, 96, 0.1)',
                            pointBackgroundColor: '#d81b60',
                            pointBorderColor: '#d81b60',
                            pointRadius: 0,
                            pointHoverRadius: 5,
                            pointHitRadius: 10,
                            borderJoinStyle: 'bevel',
                            borderCapStyle: 'butt',
                            borderWidth: 2,
                            fill: true,
                            tension: 0.4,
                            yAxisID: 'y-percentage'
                        },
                        // ── dataset 15: SAF Forwarder Count ── (capacidad, no un %
                        // — eje propio 'y-count'; informativo, sin SLA/thresholds,
                        // no hay alerting sobre esta dimensión)
                        {
                            label: 'Avg SAF Forwarder Count',
                            data: safForwarderCountData,
                            borderColor: '#6d28d9',
                            backgroundColor: 'rgba(109, 40, 217, 0.1)',
                            pointBackgroundColor: '#6d28d9',
                            pointBorderColor: '#6d28d9',
                            pointRadius: 0,
                            pointHoverRadius: 5,
                            pointHitRadius: 10,
                            borderJoinStyle: 'bevel',
                            borderCapStyle: 'butt',
                            borderWidth: 2,
                            fill: true,
                            tension: 0.4,
                            yAxisID: 'y-count'
                        },
                        {
                            label: 'Avg Frame Ingestion Rate',
                            data: frameIngestionRateData,
                            borderColor: '#0891b2',
                            backgroundColor: 'rgba(8, 145, 178, 0.1)',
                            pointRadius: 0,
                            pointHoverRadius: 5,
                            pointHitRadius: 10,
                            borderWidth: 2,
                            fill: false,
                            tension: 0.4,
                            yAxisID: 'y-frame-rate'
                        },
                        // ── dataset 17: Avg Upload Frame Rate (SAF → ingestion hub) — mismo eje que la ingesta ──
                        {
                            label: 'Avg Upload Frame Rate',
                            data: uploadFrameRateData,
                            borderColor: '#16a34a',
                            backgroundColor: 'rgba(22, 163, 74, 0.1)',
                            pointBackgroundColor: '#16a34a',
                            pointBorderColor: '#16a34a',
                            pointRadius: 0,
                            pointHoverRadius: 5,
                            pointHitRadius: 10,
                            borderJoinStyle: 'bevel',
                            borderCapStyle: 'butt',
                            borderWidth: 2,
                            fill: false,
                            tension: 0.4,
                            yAxisID: 'y-frame-rate'
                        },
                        // ── dataset 18: Avg Size Upload Rate (KB/min) — eje propio ──
                        {
                            label: 'Avg Size Upload Rate',
                            data: uploadSizeRateData,
                            borderColor: '#ca8a04',
                            backgroundColor: 'rgba(202, 138, 4, 0.1)',
                            pointBackgroundColor: '#ca8a04',
                            pointBorderColor: '#ca8a04',
                            pointRadius: 0,
                            pointHoverRadius: 5,
                            pointHitRadius: 10,
                            borderJoinStyle: 'bevel',
                            borderCapStyle: 'butt',
                            borderWidth: 2,
                            fill: false,
                            tension: 0.4,
                            yAxisID: 'y-kb-rate'
                        },
                        // ── dataset 19: Transmit Batch Size (frames por commit) — eje propio ──
                        {
                            label: 'Avg Transmit Batch Size',
                            data: transmitBatchSizeData,
                            borderColor: '#475569',
                            backgroundColor: 'rgba(71, 85, 105, 0.1)',
                            pointBackgroundColor: '#475569',
                            pointBorderColor: '#475569',
                            pointRadius: 0,
                            pointHoverRadius: 5,
                            pointHitRadius: 10,
                            borderJoinStyle: 'bevel',
                            borderCapStyle: 'butt',
                            borderWidth: 2,
                            fill: false,
                            tension: 0.4,
                            yAxisID: 'y-batch-size'
                        },
                        // ── dataset 20: Upload Responsiveness (%) — informativo, sin SLA/thresholds ──
                        {
                            label: 'Upload Responsiveness (%)',
                            data: uploadResponsivenessData,
                            borderColor: '#0d9488',
                            backgroundColor: 'rgba(13, 148, 136, 0.1)',
                            pointBackgroundColor: '#0d9488',
                            pointBorderColor: '#0d9488',
                            pointRadius: 0,
                            pointHoverRadius: 5,
                            pointHitRadius: 10,
                            borderJoinStyle: 'bevel',
                            borderCapStyle: 'butt',
                            borderWidth: 2,
                            fill: false,
                            tension: 0.4,
                            yAxisID: 'y-percentage'
                        },
                        // ── dataset 21: Hogging Rate (%) — informativo, sin SLA/thresholds ──
                        {
                            label: 'Hogging Rate (%)',
                            data: hoggingRateData,
                            borderColor: '#dc2626',
                            backgroundColor: 'rgba(220, 38, 38, 0.1)',
                            pointBackgroundColor: '#dc2626',
                            pointBorderColor: '#dc2626',
                            pointRadius: 0,
                            pointHoverRadius: 5,
                            pointHitRadius: 10,
                            borderJoinStyle: 'bevel',
                            borderCapStyle: 'butt',
                            borderWidth: 2,
                            fill: false,
                            tension: 0.4,
                            yAxisID: 'y-percentage'
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: { duration: 0 },
                    layout: { padding: { top: 10, bottom: 10 } },
                    elements: {
                        point: { radius: 0, hoverRadius: 5, hitRadius: 10 },
                        line: { borderJoinStyle: 'bevel', borderCapStyle: 'butt' }
                    },
                    interaction: { mode: 'nearest', intersect: false },
                    hover: { mode: 'nearest', intersect: false },
                    scales: {
                        x: {
                            type: 'time',
                            time: {
                                unit: timeUnit,
                                displayFormats: {
                                    second: 'HH:mm:ss',
                                    minute: 'MM/dd HH:mm',
                                    hour: 'MM/dd HH:mm',
                                    day: 'MM/dd'
                                },
                                tooltipFormat: 'MMM dd, yyyy HH:mm:ss'
                            },
                            title: { display: true, text: 'Time Interval', font: { size: 12, weight: '600' } },
                            ticks: {
                                maxRotation: 45,
                                minRotation: 45,
                                font: { size: 11 },
                                autoSkip: true,
                                maxTicksLimit: maxTicks
                            },
                            grid: { display: false },
                            min: ($scope.isLiveMode ? dataMinX : undefined),
                            max: ($scope.isLiveMode ? dataMaxX : undefined)
                        },
                        'y-percentage': {
                            type: 'linear',
                            display: true,
                            position: 'left',
                            min: 0,
                            max: 100,
                            title: { display: true, text: 'CPU / Memory / Log Pressure / Pressure (%)', font: { size: 12, weight: '600' } },
                            grid: { color: 'rgba(0, 0, 0, 0.05)' },
                            ticks: { font: { size: 11 }, callback: function (value) { return value + '%'; } }
                        },
                        'y-latency': {
                            type: 'linear',
                            display: 'auto',   // solo si alguna métrica de este eje está visible
                            position: 'right',
                            min: 0,
                            title: { display: true, text: 'Latency (ms)', font: { size: 12, weight: '600' } },
                            grid: { drawOnChartArea: false },
                            ticks: { font: { size: 11 }, callback: function (value) { return Math.round(value) + ' ms'; } }
                        },
                        'y-frame-rate': {
                            type: 'linear', display: 'auto', position: 'right', min: 0,
                            title: { display: true, text: 'Frames / min', font: { size: 12, weight: '600' } },
                            grid: { drawOnChartArea: false },
                            ticks: { font: { size: 11 } }
                        },
                        'y-kb-rate': {
                            type: 'linear', display: 'auto', position: 'right', min: 0,
                            title: { display: true, text: 'KB / min', font: { size: 12, weight: '600' } },
                            grid: { drawOnChartArea: false },
                            ticks: { font: { size: 11 } }
                        },
                        'y-batch-size': {
                            type: 'linear', display: 'auto', position: 'right', min: 0,
                            title: { display: true, text: 'Batch Size (frames)', font: { size: 12, weight: '600' } },
                            grid: { drawOnChartArea: false },
                            ticks: { font: { size: 11 }, precision: 0 }
                        },
                        'y-count': {
                            type: 'linear',
                            display: 'auto',   // solo si alguna métrica de este eje está visible
                            position: 'right',
                            min: 0,
                            title: { display: true, text: 'SAF Forwarder Count', font: { size: 12, weight: '600' } },
                            grid: { drawOnChartArea: false },
                            ticks: { font: { size: 11 }, precision: 0 }
                        }
                    },
                    plugins: {
                        legend: {
                            display: true,
                            position: 'top',
                            labels: {
                                usePointStyle: true,
                                padding: 15,
                                font: { size: 12, weight: '600' },
                                // Solo las métricas seleccionadas (sin tachadas) y nunca las líneas de threshold
                                filter: function (item) {
                                    return !item.hidden && !item.text.includes('threshold');
                                }
                            },
                            // Click en la leyenda = quitar la métrica del dropdown "Show metrics",
                            // así ambos quedan en sync (la default solo ocultaba el dataset).
                            onClick: function (e, item) {
                                var key = Object.keys(METRIC_DATASET_INDEX).filter(function (k) {
                                    return METRIC_DATASET_INDEX[k] === item.datasetIndex;
                                })[0];
                                if (!key) return;
                                $scope.$applyAsync(function () {
                                    $scope.selectedMetrics = $scope.selectedMetrics.filter(function (k) { return k !== key; });
                                    $scope.onMetricsSelectionChanged();
                                });
                            }
                        },
                        // ✅ MEJORADO: tooltip con valor y unidad correcta por dataset
                        tooltip: {
                            backgroundColor: 'rgba(0, 0, 0, 0.82)',
                            padding: 12,
                            titleFont: { size: 13, weight: 'bold' },
                            bodyFont: { size: 12 },
                            filter: function (item) {
                                // Mostrar thresholds en tooltip solo si están visibles
                                var ds = item.dataset;
                                if (ds.label && ds.label.includes('threshold')) {
                                    return !item.chart.getDatasetMeta(item.datasetIndex).hidden;
                                }
                                return true;
                            },
                            callbacks: {
                                label: function (context) {
                                    var label = context.dataset.label || '';
                                    var value = context.parsed.y;
                                    if (context.dataset.yAxisID === 'y-frame-rate') return label + ': ' + value.toFixed(1) + ' frames/min';
                                    if (context.dataset.yAxisID === 'y-kb-rate') return label + ': ' + value.toFixed(1) + ' KB/min';
                                    if (context.dataset.yAxisID === 'y-batch-size') return label + ': ' + Math.round(value) + ' frames';
                                    if (label.includes('Responsiveness') || label.includes('Hogging')) return label + ': ' + value.toFixed(1) + '%';
                                    if (label.includes('threshold')) {
                                        var unit = context.dataset.yAxisID === 'y-latency' ? ' ms' : '%';
                                        return '⚑ ' + label.replace(' threshold', '') + ': ' + value + unit;
                                    }
                                    if (label.includes('CPU') || label.includes('Memory')) {
                                        return label + ': ' + value.toFixed(1) + '%';
                                    }
                                    if (label.includes('Latency')) {
                                        return label + ': ' + Math.round(value) + ' ms';
                                    }
                                    return label + ': ' + value;
                                }
                            }
                        }
                    }
                }
            });

            applyMetricVisibility();
            applyThresholdVisibility();
            chartInstance.update();

        } catch (e) {
            console.error('❌ Error creating chart:', e);
        }
    };

    // ===== DIALOG ACTIONS =====

    $scope.close = function () {
        if ($scope.isLiveMode) {
            stopLiveMonitoring();
        }

        if (chartInstance) {
            chartInstance.data.datasets.forEach(function (dataset) {
                dataset.data = [];
            });
            chartInstance.update();
        }

        if (intervalChangeTimeout) $timeout.cancel(intervalChangeTimeout);
        if (timeRangeChangeTimeout) $timeout.cancel(timeRangeChangeTimeout);

        $mdDialog.hide();
    };

    // ===== CLEANUP =====

    $scope.$on('$destroy', function () {
        stopLiveMonitoring();

        if (chartInstance) {
            LiveChartViewport.cancel(chartInstance); chartInstance.destroy();
            chartInstance = null;
        }
        if (intervalChangeTimeout) $timeout.cancel(intervalChangeTimeout);
        if (timeRangeChangeTimeout) $timeout.cancel(timeRangeChangeTimeout);
        if (_dropdownPanelObserver) _dropdownPanelObserver.disconnect();
    });

    // ===== INITIALIZATION =====

    initializeTimeRange();
});